<template>
	<div class="user_content_blcok">
		<div class="user_content_blcok_title">
			收货地址<span>
				<el-button size="mini" type="danger" @click="dialogVisible = true">新增</el-button>
			</span>
		</div>
		<div class="user_content_blcok_line"></div>
		<div class="user_content_block_show">
			<div class="user_address_list">
				<ul>
					<li v-for="(v,k) in address_list" :key="k">
						<dl>
							<dt><img width="32px" height="32px" src="/pc/address_pos.jpg" alt=""></dt>
							<dd>{{v.linkName}}</dd>
							<dd class="address_info">{{v.statesName+' '+v.citysName+' '+v.zonesName+' '+v.linkAdds}}
								{{v.linkTel}}
							</dd>
						</dl>
						<div class="address_handle">
							<span v-show="false" @click="set_default(v.id)">设置默认</span><span class="red"
								v-show="v.isDef==1"><i class="icon iconfont">&#xeb96;</i>默认地址</span>
							<span @click="get_address_info(v.id)">编辑</span>|<span @click="del(v.id)">删除</span>
						</div>
						<div class="clear"></div>
					</li>
				</ul>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisible" :title="edit_id>0?'编辑收货地址':'新增收货地址'" @close="close_dialog">
			<div class="home_form_main">
				<el-form label-width="100px" ref="info" :model="info">
					<el-form-item label="收货人" prop="linkName"
						:rules="[{required:true,message:'收货人不能为空',trigger: 'blur' }]">
						<el-input placeholder="请输入内容" v-model="info.linkName"></el-input>
					</el-form-item>
					<el-form-item label="手机" prop="linkTel"
						:rules="[{required:true,message:'手机不能为空',trigger: 'blur' }]">
						<el-input placeholder="请输入内容" v-model="info.linkTel"></el-input>
					</el-form-item>
					<el-form-item label="地址" prop="area_info"
						:rules="[{required:true,message:'地址不能为空',trigger: 'blur' }]">
						<el-cascader v-model="info.area_info" :props="props" :options="area_list">
						</el-cascader>
					</el-form-item>
					<el-form-item label="详细地址" prop="linkAdds"
						:rules="[{required:true,message:'详细地址不能为空',trigger: 'blur' }]">
						<el-input placeholder="请输入内容" v-model="info.linkAdds"></el-input>
					</el-form-item>
					<el-form-item label="订购人姓名" prop="buyerName"
						:rules="[{required:true,message:'订购人姓名不能为空',trigger: 'blur' }]">
						<el-input placeholder="请输入订购人姓名" v-model="info.buyerName"></el-input>
					</el-form-item>
					<el-form-item label="订购人身份证号码" prop="buyerIdCardNo"
						:rules="[{required:true,message:'订购人身份证号码不能为空',trigger: 'blur' }]">
						<el-input placeholder="请输入订购人身份证号码" v-model="info.buyerIdCardNo"></el-input>
					</el-form-item>
					<el-form-item label="默认收货地址" prop="isDef">
						<el-switch v-model="addressDefault" active-color="#ca151e"></el-switch>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="danger" @click="submitForm('info')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAddress,
		getAddressById,
		editAddress,
		addAddress
	} from '../../../api/api.js'
	import areas from '@/assets/areas.json'
	export default {
		components: {},
		props: {},
		data() {
			return {
				dialogVisible: false,
				edit_id: 0,
				info: {},
				addressDefault: false,
				area_list: [],
				areaInfoKey: 1,
				address_list: [],
				// 省市区动态加载
				props: {
					value: 'name',
					label: 'name',
				},
			};
		},
		watch: {},
		computed: {},
		methods: {
			submitForm: function(e) {
				let _this = this;

				// 验证表单
				this.$refs[e].validate(function(res) {
					if (res) {
						//  判断是Add 或者 Edit
						let url = _this.$api.addAddress;
						_this.info.isDef = _this.addressDefault == true ? 1 : 0;
						_this.info.statesName = _this.info.area_info[0]
						_this.info.citysName = _this.info.area_info[1]
						_this.info.zonesName = _this.info.area_info[2]
						if (_this.edit_id > 0) {
							editAddress(_this.info).then(function(res) {
								if (res.code == 0) {
									_this.$message.success("编辑成功");
									_this.dialogVisible = false;
									_this.get_address_list();
								} else {
									_this.$message.error("编辑失败," + res.msg);
								}
							});
						} else {
							addAddress(_this.info).then(function(res) {
								if (res.code == 0) {
									_this.$message.success("新增成功");
									_this.dialogVisible = false;
									_this.get_address_list();
								} else {
									_this.$message.error("新增失败," + res.msg);
								}
							});
						}
					}
				});
			},
			get_area_list: function() {
				this.area_list = areas;
			},
			get_address_list: function() {
				getAddress().then(res => {
					this.address_list = res.data;
				});
			},
			get_address_info: function(id) {
				this.edit_id = id;
				this.dialogVisible = true;
				getAddressById(id).then(res => {
					this.info = res.data;
					this.info.area_info = [this.info.statesName, this.info.citysName, this.info.zonesName]
					this.addressDefault = res.data.isDef == 0 ? false : true;
				});
			},
			set_default: function(id) {
				this.$post(this.$api.setDefaultAddress, {
					id: id
				}).then(res => {
					this.get_address_list();
					return this.$message.success('设置默认地址成功');
				});
			},
			// 删除处理
			del: function(id) {
				let _this = this;
				this.$post(this.$api.delAddress, {
					id: id
				}).then(function(res) {
					if (res.code == 200) {
						_this.get_address_list();
						return _this.$message.success("删除成功");
					} else {
						return _this.$message.error("删除失败");
					}
				});
			},
			close_dialog: function() {
				this.edit_id = 0;
			}
		},
		created() {
			this.get_address_list();
			this.get_area_list();
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>
	.user_address_list {
		padding-top: 10px;

		ul li {
			margin-bottom: 20px;
			padding-bottom: 20px;
			border-bottom: 1px solid #efefef;

			dl {
				float: left;
				display: block;
				width: 650px;

				dt {
					float: left;
					margin-right: 20px;

					img {
						border-radius: 50%;
					}
				}

				dd {
					line-height: 20px;
					width: 190px;
					width: 500px;
					float: left;
				}

				dd.address_info {
					color: #999;
					float: left;
					width: 100%;
					width: 500px;
				}
			}

			.address_handle {
				color: #666;
				float: right;
				line-height: 40px;

				span {
					margin: 0 10px;

					i {
						margin-right: 10px;
					}

				}

				span:hover {
					color: #ca151e;
				}

				span.red {
					color: #ca151e;
				}
			}
		}
	}
</style>
